<ng-container *ngIf="!confirmSignUp">
  <h4>Souhaitez-vous vous inscrire avec les informations suivantes : </h4>
  <div *ngIf="userRS">
    <p>Nom: <strong>{{userRS.lastName}}</strong></p>
    <p>Prénom: <strong>{{userRS.firstName}}</strong></p>
    <p>Email: <strong>{{userRS.email}}</strong></p>
  </div>

  <div class="btn_action" *ngIf="!isLoading">
    <button mat-dialog-close class="back">Annuler</button>
    <button cdkFocusInitial class="confirm" (click)="confirmToRegister()">Confirmer</button>
  </div>
  <mat-spinner diameter="50" *ngIf="isLoading"></mat-spinner>
</ng-container>

<app-validation-animation *ngIf="confirmSignUp" [text]="'Votre compte a bien été créé'"></app-validation-animation>